const OPTION_TITLES = [
    { value: 1, label: '商材についてのお問い合わせ' },
    { value: 2, label: '事業者へお問い合わせ' },
    { value: 3, label: 'その他' }
]

export { OPTION_TITLES }
